var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanoeAndGuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 170,
    viewBox: "0 0 182 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "canoeAndGuy",
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personAndShovel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "head",
    d: "M86.8754 35.647C94.9383 36.3541 102.01 30.822 102.67 23.2908C103.331 15.7595 97.33 9.08107 89.2672 8.37399C81.2043 7.66691 74.1327 13.199 73.4722 20.7302C72.8118 28.2614 78.8126 34.9399 86.8754 35.647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body",
    d: "M96.0968 66.5709L80.7464 56.6087L108.441 66.9028C108.441 66.9028 108.441 66.9029 108.442 66.9034C110.639 67.7193 113.153 67.4508 115.069 66.2042L138.112 51.2025C141.293 49.1323 142.055 45.0168 139.795 42.0096C139.794 42.0084 139.794 42.0073 139.793 42.0067C137.552 39.0277 133.13 38.2521 129.943 40.3266L109.992 53.3139L84.9124 43.9922C97.5951 45.4778 100.133 45.7752 108.184 46.7177L119.044 39.6472L133.733 22.4139C131.704 22.1214 129.566 22.6499 127.942 24.0325L108.97 40.1815L97.2523 40.8714C97.2523 40.8714 86.8153 39.7503 77.6469 38.9516C72.2005 38.4739 67.4231 42.2108 66.977 47.2986C66.6474 51.0568 64.3783 76.9318 63.893 82.4655C69.2606 83.57 74.7811 84.4127 80.4072 84.9782C83.6182 81.2117 87.4877 76.6713 96.0968 66.5709V66.5709Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shovel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M139.466 35.8795L148.102 24.626C149.837 22.3645 149.382 19.1424 147.085 17.428C144.788 15.7131 141.518 16.1578 139.784 18.4179L129.448 31.8861C133.364 31.6864 136.965 33.2277 139.466 35.8795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M100.867 69.1283L59.043 123.627L71.537 124.394L111.73 72.0207C106.059 73.1384 103.038 70.5256 100.867 69.1283V69.1283Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "boat",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1717 119.027C87.477 119.027 86.7846 119.023 86.0939 119.014L112.663 81.6696C130.461 79.0467 146.377 73.6366 159.045 66.2841C161.858 64.6514 165.549 65.7901 166.784 68.6333C168.029 71.4993 168.703 74.4746 168.703 77.5355C168.703 100.449 132.642 119.027 88.1717 119.027ZM81.608 83.3131L58.2974 116.077C28.6116 109.964 7.64009 95.012 7.64009 77.5357C7.64009 74.4758 8.31834 71.5016 9.56341 68.6372C10.8011 65.7887 14.5052 64.6664 17.3014 66.2891C34.0902 76.0303 56.5868 82.3635 81.608 83.3131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.414 130.729C26.414 133.647 28.9471 136.013 32.0708 136.013H80.9231C84.0467 136.013 86.5799 133.647 86.5799 130.729C86.5799 127.812 84.0467 125.445 80.9231 125.445H32.0708C28.9471 125.445 26.414 127.812 26.414 130.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M168.703 142.612H74.2752C71.1509 142.612 68.6184 144.978 68.6184 147.896C68.6184 150.814 71.1509 153.18 74.2752 153.18H168.703C171.827 153.18 174.36 150.814 174.36 147.896C174.36 144.978 171.827 142.612 168.703 142.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.4767 159.432H14.555C11.4307 159.432 8.89815 161.798 8.89815 164.716C8.89815 167.634 11.4307 170 14.555 170H58.4767C61.601 170 64.1335 167.634 64.1335 164.716C64.1335 161.798 61.601 159.432 58.4767 159.432Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 170,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanoeAndGuy);
export default __webpack_public_path__ + "static/media/canoeAndGuy.2bb423631a77fdf9d48b888691002f79.svg";
export { ForwardRef as ReactComponent };